module.exports = __webpack_public_path__ + "static/img/icon_success.9d78fdb6.svg";